const jackfruitPulpData = {
  hero_section: {
    title: "Premium Jackfruit Pulp Collection",
    description: "100% Natural • No Preservatives • Traditional Favorite",
    src: "videos/jackfruit-processing.webm",
  },
  description: {
    title: "Premium Jackfruit Pulp Collection",
    main_description:
      "Discover our range of 100% natural jackfruit pulp, crafted from the finest jackfruits to preserve the authentic sweet flavor and traditional appeal.",
    segment_description:
      "Perfect for traditional desserts, innovative culinary applications, and specialty foods.",
    variety_description:
      "Available in various grades and pack sizes to suit every commercial need.",
  },
  main_product: {
    title: "Premium Jackfruit Pulp",
    description: "Our jackfruit pulp captures the unique sweet flavor and aroma of this traditional favorite. Perfect for desserts, specialty foods, and innovative culinary applications that require authentic jackfruit taste.",
    image: "New-Images/Jack fruit.png",
    mainFeatures: [
      "Authentic traditional flavor",
      "Unique sweet taste profile",
      "Rich aromatic qualities",
      "Perfect for desserts",
      "Traditional processing methods",
      "Consistent quality and texture"
    ],
    nutrition: {
      servingSize: "100g",
      calories: "100",
      fat: "0g",
      carbs: "12g (Sugar: 11g, Added: 15g)",
      fiber: "1g",
      protein: "1g",
      sodium: "20mg",
      potassium: "210mg"
    }
  },
  products: [
    {
      id: "1",
      name: "Premium Jackfruit Pulp",
      image: "New-Images/Jack fruit.png",
      features: [
        "Authentic jackfruit flavor",
        "Sweet aromatic profile",
        "Traditional favorite",
        "Perfect for desserts"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    }
  ],

  text_section: {
    title: "Jackfruit Pulp Excellence",
    description: "Our jackfruit pulp is processed from the finest handpicked jackfruits using traditional and modern processing techniques. We maintain strict quality control to ensure consistent flavor, texture, and authenticity in every batch.",
  },
  
  feature_text_section: {
    title: "Perfect for Traditional & Modern Applications",
    subline: "From traditional desserts to innovative foods – authentic jackfruit flavor in every application!",
    description:
      "Ideal for dessert manufacturers, traditional sweet makers, innovative food producers, and culinary professionals who value authentic tropical flavors.",
  },
  
  feature_cards_info_card: [
    {
      id: 1,
      image: "dessert-applications.webp",
      title: "Traditional Dessert Applications",
      description:
        "Perfect for traditional sweets, desserts, and confectionery products requiring authentic jackfruit taste.",
    },
    {
      id: 2,
      image: "culinary-applications.webp",
      title: "Culinary Applications",
      description:
        "Ideal for innovative culinary creations, specialty foods, and gourmet applications with unique flavor profiles.",
    },
    {
      id: 3,
      image: "food-service-applications.webp",
      title: "Specialty Food Service",
      description:
        "Excellent for restaurants, specialty cafes, and catering services offering traditional and innovative jackfruit dishes.",
    },
  ],
  
  overlay_card: [
    {
      id: 1,
      key: "Natural Processing",
      image: "natural-processing.webp",
      title: "Natural Processing",
      description:
        "No artificial preservatives, colors, or additives—just pure, natural jackfruit goodness",
    },
    {
      id: 2,
      key: "Quality Assurance",
      image: "quality-assurance.webp",
      title: "Quality Assurance",
      description:
        "Rigorous testing and quality control at every stage ensures premium standards",
    },
    {
      id: 3,
      key: "Consistent Supply",
      image: "consistent-supply.webp",
      title: "Consistent Supply",
      description:
        "Reliable production capacity and supply chain for your business needs",
    },
    {
      id: 4,
      key: "Traditional Excellence",
      image: "traditional-excellence.webp",
      title: "Traditional Excellence",
      description:
        "Preserving traditional flavors while meeting modern quality standards",
    },
  ],
  
  why_choose_section: {
    title: "Why Choose Our Jackfruit Pulp",
    description: "Discover the perfect blend of traditional authenticity and modern quality standards that make our jackfruit pulp the preferred choice for specialty food manufacturers worldwide.",
  },
};

export default jackfruitPulpData;
